import { render, staticRenderFns } from "./SucursalCategoriasHome.vue?vue&type=template&id=5a517bcb&scoped=true&"
import script from "./SucursalCategoriasHome.vue?vue&type=script&lang=js&"
export * from "./SucursalCategoriasHome.vue?vue&type=script&lang=js&"
import style0 from "./SucursalCategoriasHome.vue?vue&type=style&index=0&id=5a517bcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a517bcb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
